<template>
  <v-list-group active-class="primary white--text" :value="false">
    <template v-slot:activator>
      <v-list-item-icon class="mr-4">
        <v-icon>mdi-school</v-icon>
      </v-list-item-icon>
      <v-list-item-title>Giảng dạy</v-list-item-title>
    </template>
    <v-list class="py-0">
      <v-list-item active-class="blue lighten-4 primary--text" class="px-0" link to="/teachingPlan">
        <v-list-item-action></v-list-item-action>
        <v-list-item-title>Kế hoạch giảng dạy</v-list-item-title>
      </v-list-item>
      <v-list-item active-class="blue lighten-4 primary--text" class="px-0" link to="/teachingPlanProgressReport">
        <v-list-item-action></v-list-item-action>
        <v-list-item-title>Báo cáo tiến độ khai KHGD</v-list-item-title>
      </v-list-item>
      <v-list-item active-class="blue lighten-4 primary--text" class="px-0" link to="/teachingProgressReport">
        <v-list-item-action></v-list-item-action>
        <v-list-item-title>Báo cáo tiến độ giảng dạy</v-list-item-title>
      </v-list-item>
      <v-list-item class="px-0" active-class="blue lighten-4 primary--text" link to="/teachingTimeTable">
        <v-list-item-action></v-list-item-action>
        <v-list-item-title>Thời khóa biểu</v-list-item-title>
      </v-list-item>
      <v-list-item class="px-0" active-class="blue lighten-4 primary--text" link to="/teacherClassNotes">
        <v-list-item-action></v-list-item-action>
        <v-list-item-title>Sổ ghi đầu bài</v-list-item-title>
      </v-list-item>
      <v-list-item class="px-0" active-class="blue lighten-4 primary--text" link to="/marks-input">
        <v-list-item-action></v-list-item-action>
        <v-list-item-title>Nhập điểm</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-list-group>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data() {
    return { menu: null }
  },
  computed: {
    ...mapGetters('auth', ['user', 'role']),
  },
}
</script>

<style scoped></style>
